// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.referencesTimeline .referenceForm .messageBox {
  margin: 8px 0;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/pages/CandidateReferences/ReferenceForm.less"],"names":[],"mappings":"AAAA;EAEE,aAAA;EACA,WAAA;AAAF","sourcesContent":[".referencesTimeline .referenceForm {\n\t.messageBox {\n\t\tmargin: 8px 0;\n\t\twidth: 100%;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
